Vue.component('Dropdown', () => import('./Dropdown'))
Vue.component('DropdownItem', () => import('./DropdownItem'))